
import Breadcrumbs from '~/components/UI/Breadcrumbs';
import MainContent from '~/components/object/MainContent.vue';
import CalculatorIpoteka from '~/components/object/CalculatorIpoteka.vue';
import ProductMixin from '../../node_modules/sitis-nuxt/lib/mixins/ProductMixin';

export default {

  components: {
    Breadcrumbs,
    MainContent,
    CalculatorIpoteka,

    SliderImages: () => import('~/components/object/SliderImages'),
    TableOtherObject: () => import('~/components/object/TableOtherObject'),
    WidgetPopup: () => import('~/components/object/WidgetPopup.vue'),
  },

  mixins: [
    ProductMixin,
  ],

  data() {
    return {
      productCategory: {},
      isShowWidgetPopup: false,
      widgetLink: null,
    };
  },
  head() {
    const title = this.product?.seo?.title || this.product?.metaTitle || this.product?.title || '';
    const head = {
      title,
      meta: [],
    };

    if (title) {
      head.meta.push({
        name: 'og:title',
        hid: 'og:title',
        property: 'og:title',
        content: title,
      });
    }

    const description = this.product?.seo?.description || this.product?.metaDescription || '';
    if (description) {
      head.meta.push({
        hid: 'metadescription',
        name: 'description',
        content: description
      });
      head.meta.push({
        name: 'og:description',
        hid: 'og:description',
        property: 'og:description',
        content: description,
      });
    }

    const image = this.product?.imageId ? this.$img(String(this.product?.imageId)) : null;
    if (image) {
      head.meta.push({
        name: 'og:image',
        hid: 'og:image',
        property: 'og:image',
        content: image,
      });
    }

    return head;
  },

  computed: {
    breadcrumbs() {
      return [];
    },
    characteristics() {
      const list = [];
      (this.product?.characteristics || []).map((t) => {
        list.push(...t.characteristics);
      });

      return list;
    },

    title() {
      if (this.product?.characteristicGroupId === 2) {
        const room = this.characteristics.find((t) => t.slug === 'rooms')?.values?.[0]?.value;
        const slug = this.characteristics.find((t) => t.slug === 'rooms')?.values?.[0]?.slug;
        if (slug === 'studiya') {
          return `${room} ${this.product.name}`;
        }

        return `${room}-комнатная квартира ${this.product.name}`;
      }
      if (this.product?.characteristicGroupId === 1) {
        return `№ паркинга ${this.product?.name}`;
      }
      return this.product?.name;
    },
    characteristicsList() {
      return this.characteristics.filter((t) => t.showInProduct);
    },
    productImages() {
      let images = [...(this.product?.imageIds || [])];

      // Логика фото "План на этаже"
      const imageIdFloorPlan = (this.product?.images || []).find((t) => Boolean(t?.caption === "План на этаже"))?.imageId || null;
      if (!!imageIdFloorPlan) {
        const imageIndex = images.findIndex((t) => Boolean(String(t) === String(imageIdFloorPlan)));
        images.splice(1,0,images.splice(imageIndex, 1)[0]);
      }

      return images;
    },

    isVisibleButtonBack() {
      if (!process.client) {
        return false;
      }

      return window.history?.length > 2;
    },
    cmsPageId() {
      const id = this.$store.state?.appState?.vars?.['ID CMS контент страницы товара'] || '';
      if (!id) {
        return;
      }

      return Number.parseFloat(id);
    },

    extensions: function () {
      return ['seo_heading', 'images'];
    },
    visibleTableOtherObject: function () {
      return Boolean(this.product?.characteristicGroupId === 2);
    }
  },

  async mounted() {
    await this.getProductCategory();
  },

  methods: {
    async getProductCategory() {
      const categoryId = this.product?.category?.id;
      if (!categoryId || Object.keys(this.productCategory).length > 0) {
        setTimeout(async () => {
          await this.getProductCategory();
        }, 500);

        return;
      }

      const response = await this.$api.agent.transport.get(`/categories/${categoryId}`)
        .then((res) => res.data)
        .catch(() => ({}));
      this.productCategory = response;
    },

    goBack() {
      if (!this.isVisibleButtonBack) {
        this.$router.push('/apartments');

        return;
      }

      this.$router.back();
    },

    onMakeRequest() {
      const message = `Заявка на бронирование квартиры "${this.product.name}"`;
      const additional_data = {
        macro_id: parseInt((this.product?.code || '').match(/\d+/)),
      };

      this.$store.commit('back-call/setOpen', {
        open: true,
        settings: {
          title: 'Оформление заявки',
          subtitle: 'Для бронирования свяжитесь с менеджером по телефону или через WhatsApp',
          formType: 'Бронирование квартиры',
          message,
          additional_data,
          reachGoal: 'oformut_saavky_kartogka',
        },
      });
    },

    _parceCharacteristicValue(characteristic) {
      const value = characteristic?.values?.[0]?.value;

      if (characteristic.filterType === 1) {
        return [this.$numberFormat(value), characteristic.unit]
          .filter((t) => !!t)
          .join(' ');
      }

      return [value, characteristic.unit]
        .filter((t) => !!t)
        .join(' ');
    },

    openWidgetPopup: function (link) {
      this.isShowWidgetPopup = true;
      this.widgetLink = link;
    },
    closeWidgetPopup: function () {
      this.isShowWidgetPopup = false;
      this.widgetLink = null;
    }
  },

};
